import { render, staticRenderFns } from "./INCAMetrics.vue?vue&type=template&id=411448d2&scoped=true&lang=pug"
import script from "./INCAMetrics.vue?vue&type=script&lang=js"
export * from "./INCAMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411448d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411448d2')) {
      api.createRecord('411448d2', component.options)
    } else {
      api.reload('411448d2', component.options)
    }
    module.hot.accept("./INCAMetrics.vue?vue&type=template&id=411448d2&scoped=true&lang=pug", function () {
      api.rerender('411448d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/audit_monitoring/INCAMetrics.vue"
export default component.exports